import type { ApprovalRequest } from '@titan/shared';
import { useCallback, useState } from 'react';

/**
 * Mutations that need a second person answer 202 with the pending request instead of
 * applying. Screens pass every mutation result through `check` and show the notice.
 */
export function useApprovalNotice() {
  const [notice, setNotice] = useState<string | null>(null);
  const check = useCallback((res: unknown): unknown => {
    const pending = (res as { pending?: ApprovalRequest | null } | null)?.pending;
    if (pending) {
      setNotice(`Sent for approval: ${pending.summary} A second superadmin or DinoCloud has to approve it before ${new Date(pending.expiresAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}. Nothing changes until then.`);
    }
    return res;
  }, []);
  const clear = useCallback(() => setNotice(null), []);
  return { notice, check, clear };
}
